import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  addCardToStoreAction,
  setNextCardPositionToStore,
  cancelLastCardUsedAction,
} from 'data/reducers';
import { AddedCardResponse, CardPosition, Notifications } from 'types';

export function* addedNewCard({ type: notificationType, data: result }: AddedCardResponse) {
  try {
    if (notificationType === Notifications.NEW_CARD_ADDED) {
      const { card, position } = result;
      yield put(addCardToStoreAction({ card, position: position.toString() as CardPosition }));
      yield put(setNextCardPositionToStore(null));
      yield put(cancelLastCardUsedAction(false));
    }
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
  }
}
